import { render, staticRenderFns } from "./SettingsDropdown.vue?vue&type=template&id=58a12b12&"
import script from "./SettingsDropdown.vue?vue&type=script&lang=js&"
export * from "./SettingsDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58a12b12')) {
      api.createRecord('58a12b12', component.options)
    } else {
      api.reload('58a12b12', component.options)
    }
    module.hot.accept("./SettingsDropdown.vue?vue&type=template&id=58a12b12&", function () {
      api.rerender('58a12b12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/TemplateManager/Components/Settings/SettingsDropdown.vue"
export default component.exports